module.exports = __webpack_public_path__ + "img/sphere06-graph-black.450d3c4c.png";